import React from "react";
import Div from "../lib/Div";
import P from "../lib/P";
import {isFullSwing} from "../constants";

const TransactionHistoryHeader = () => {

  return (
    <>
      {isFullSwing ? (
        <Div row mx={15} mb={2}>
          <Div w={190} row>
            <P w={45} ta="center" fontFamily="DavisSans-Regular" fs={13} color="#BBBCBF" lh={20}>ID</P>
            <P ml={10} flex={1} ta="center" fontFamily="DavisSans-Regular" fs={13} color="#BBBCBF" lh={20}>Transaction</P>
          </Div>

          <P flex={1} ta="center" fontFamily="DavisSans-Regular" fs={13} color="#BBBCBF" lh={20}>Amount</P>
          <P w={90} ta="center" fontFamily="DavisSans-Regular" fs={13} color="#BBBCBF" lh={20}>Result</P>
        </Div>
      ) : (
        <Div row mx={30}>
          <P fw="700" lh={33} ta="center" fs={12} flex={1}>TIME</P>

          <P fw="700" lh={33} ta="center" fs={12} flex={1}>TYPE</P>

          <P fw="700" lh={33} ta="center" fs={12} flex={1}>AMOUNT</P>

          <P fw="700" lh={33} ta="center" fs={12} flex={1}>STATUS</P>
        </Div>
      )}
    </>
  );
};

export default React.memo(TransactionHistoryHeader);
